
import { Vue, Component } from "vue-property-decorator";

@Component({})
export default class SimulateCodeUse extends Vue {

  private loading: boolean = false;
  private externalId: string = "";
  private code: string = "";

  private async simulateCodeUse(): Promise<void> {
    this.loading = true;
    await this.$store.dispatch("connectorConnectedBoxes/simulateCodeUse", {
      externalId: this.externalId,
      code: this.code,
    }).then(() => {
      this.$store.commit("alerts/displaySuccess", {
        msg: this.$t("sav.simulateCodeUse.success"),
      });
    }).catch((error) => {
      this.$store.commit("alerts/displayHttpError", { error });
    }).finally(() => {
      this.loading = false;
    });
  }
}
